/**
 * @class ABDOUtil
 */
function ABDOUtil() {
} 

if (typeof(window) !== "undefined") {
    // iOSやアンドロイドのデバイスには
    // https://stackoverflow.com/questions/18201361/how-to-replace-click-with-touchstart-on-ios-devices 
    ABDOUtil.hasTouchScreen = 'ontouchend' in document.documentElement;
    ABDOUtil.clickHandler =  ABDOUtil.hasTouchScreen ? "touchend" : "click";
    ABDOUtil.supportsAnimation = typeof(window.onanimationend) !== 'undefined';
    ABDOUtil.isDebugging = document.URL.split('/').pop()[0] == "_";
    ABDOUtil.isIE = typeof(document.documentMode) !== 'undefined'; 
    

    ABDOUtil.supportsWebGL = false; 
    var canvas = document.createElement("canvas"); 
    var gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
    // Report the result.
    if (gl && gl instanceof WebGLRenderingContext) {
        ABDOUtil.supportsWebGL = true;
    }
} 


/**
 * Gets the name of the "click" handler
 * @param {HTMLElement} element 
 * @returns 
 */
ABDOUtil.getClickHandler = function(element) {
    var touchstart_tags = ['A', 'IMG'];

    var tag_in_touchstart_tags = touchstart_tags.indexOf(element.tagName) !== -1;
    if (tag_in_touchstart_tags && ABDOUtil.hasTouchScreen) {
        if(typeof(document.ontouchend) !== 'undefined') {
            return 'touchend';
        }
        else {
            return 'touchstart';
        }
    }

    var click_tags = ['BUTTON'];
    var tag_in_click_tags = click_tags.indexOf(element.tagName) !== -1;
    if (tag_in_click_tags) {
        return 'click';
    }
    
    return ABDOUtil.clickHandler;
};

ABDOUtil.setClickHandler = function(element, handler_fn) {
    element.addEventListener(ABDOUtil.getClickHandler(element), handler_fn);
}

ABDOUtil.getJSON = function(url, success, fail) {
    var request = new XMLHttpRequest();
    request.addEventListener('load', function(evt) {
        if (request.status == 0 || (request.status >= 200 && request.status < 400)) {
            try {
                var json = JSON.parse(request.responseText);
                if (typeof(abdo_osd) !== "undefined") {
                    abdo_osd.addCache(url);
                }
            }
            catch (e){
                if (fail) {
                    fail(e, request);
                }
                return;
            }
            success(json);
        }
    });
    request.open('GET', url);
    request.send();
};

ABDOUtil.loadHTML = function(url) {
    var request = new XMLHttpRequest();
    request.addEventListener('load', function(evt) {
        if (request.status == 0 || (request.status >= 200 && request.status < 400)) {
            var div = document.createElement('div');
            div.innerHTML = request.responseText;
            for ( ; div.children.length > 0; ) {
                var child_element = div.children[div.children.length - 1];
                document.body.appendChild(child_element);
            } 

            if (typeof(abdo_osd) !== "undefined") {
                abdo_osd.addCache(url);
            }
        }
    });
    request.open('GET', url);
    request.send();
};

/**
 * Clones an object
 * @param {Object} obj 
 * @param {Boolean} deep 
 * @returns {Object} the cloned object
 */
ABDOUtil.clone = function(obj, deep) {
    if (typeof(deep) === 'undefined') {
        deep = false;
    }

    if (obj == null) {
        return null;
    }

    if (Array.isArray(obj)) {
        var cloned_arr = [];
        obj.forEach(function(element){
            if (deep) {
                element = ABDOUtil.clone(element, deep);
            }
            cloned_arr.push(element);
        });
        return cloned_arr;
    }

    if (typeof(obj) == 'string') {
        return obj.repeat(1);
    }

    var newobj = {};
    for (var property in obj) {
        if (obj.hasOwnProperty(property)) {
            if (deep && obj[property] != null && typeof(obj[property]) === 'object') {
                newobj[property] = ABDOUtil.clone(obj[property], deep);
            }
            else { 
                newobj[property] = obj[property];
            } 
        }
    }

    return newobj;
};

/**
 * Checks if dataset contains a list of attributes
 * @param {DOMStringMap} dataset 
 * @param {Array} attributes 
 * @returns {Boolean}
 */
ABDOUtil.datasetHasAttributes = function(dataset, attributes)  { 
    for (var att_index = 0; att_index < attributes.length; att_index++) {
        var attribute = attributes[att_index];
        if (!(attribute in dataset)) {
            return false;
        }
    }
    return true;
};

ABDOUtil.getRectFromDataset = function(element) {
    var rect_attributes = ["fromX", "fromY", "toX", "toY"];
    var rect_attributes_alternative = ["fromX", "fromY", "width", "height"];

    var fromX, fromY, toX, toY, width, height;

    if (ABDOUtil.datasetHasAttributes(element.dataset, rect_attributes)) {
        fromX  = parseFloat(element.dataset.fromX);
        fromY  = parseFloat(element.dataset.fromY);
        toX    = parseFloat(element.dataset.toX);
        toY    = parseFloat(element.dataset.toY);
        width  = parseFloat(toX - fromX);
        height = parseFloat(toY - fromY);
        
        return new OpenSeadragon.Rect(fromX, fromY, width, height);
    }
    else if (ABDOUtil.datasetHasAttributes(element.dataset, rect_attributes_alternative)) {
        fromX  = parseFloat(element.dataset.fromX);
        fromY  = parseFloat(element.dataset.fromY); 
        width  = parseFloat(element.dataset.width);
        height = parseFloat(element.dataset.height);
        
        return new OpenSeadragon.Rect(fromX, fromY, width, height);
    }

    return null; 
};

ABDOUtil.getPointFromDataset = function(element) {
    var point_attributes = ["x", "y"];
    if (ABDOUtil.datasetHasAttributes(element.dataset, point_attributes)) {
        var x = parseFloat(element.dataset.x);
        var y = parseFloat(element.dataset.y);
        return new OpenSeadragon.Point(x,y);
    }
    
    return null;
};

// data-xとdata-yがあればOpenSeadragon.Point
// data-<from,to>-<x,y>のデータセットの要素があればOpenSeadragon.Rect
ABDOUtil.getLocationFromDataset = function(element) { 
    var rect = ABDOUtil.getRectFromDataset(element);
    if (rect != null) {
        return rect;
    }

    var pt = ABDOUtil.getPointFromDataset(element);
    if (pt != null) {
        return pt;
    } 
};

ABDOUtil.isOSDPoint = function(object) {
    return OpenSeadragon.Point.prototype.isPrototypeOf(object);
};

ABDOUtil.isOSDRect = function(object) {
    return OpenSeadragon.Rect.prototype.isPrototypeOf(object);
};

ABDOUtil.isOverlay = function(object) {
    return OpenSeadragon.Overlay.prototype.isPrototypeOf(object);
};

ABDOUtil.getViewer = function() {
    var viewer = null;
    if ( typeof(abdo_osd) !== "undefined" && abdo_osd.viewers.length > 0) {
        viewer = abdo_osd.viewers[0];
    }
    return viewer;
};

ABDOUtil.getViewers = function() {
    return abdo_osd.viewers; 
};

/**
 * Adds Emitter capabilities and a mouse tracker to the element.
 * 
 * It emits a "clicked" event on element.abdo_events when the clickHandler of its MouseTracker is called
 */
ABDOUtil.prepareClickEvent = function(element) {
    if (!element.abdo_events) {
        element.abdo_events = {};
        Emitter(element.abdo_events);
    }

    if (!element.tracker) {
        var mouse_tracker = new OpenSeadragon.MouseTracker({
            element: element,
            preProcessEventHandler: function(eventInfo) {
                eventInfo.preventDefault = false;
            },
            clickHandler: function(evt) {
                // if OSD 3.0
                if (typeof(evt.quick) !== "undefined") {
                    // if not dragging (quick mouse event)
                    if (evt.quick) {
                        element.abdo_events.emit("clicked", evt);    
                    }
                }
                // if OSD 2.x
                else {
                    element.abdo_events.emit("clicked", evt);
                }
            }
        });
        element.tracker = mouse_tracker;
    }
},

ABDOUtil.preventCanvasPropagation = function(element) { 
    if (typeof(element.tracker) === 'undefined')  {

        // Add emitter structure such that multiple click handlers are available
        if (!element.abdo_events) {
            element.abdo_events = {};
            Emitter(element.abdo_events);
        }

        var mouse_tracker = new OpenSeadragon.MouseTracker({
            element: element,
            // clickHandler: null, // when is null, OpenSeadragon does not call event.preventDefault()
            clickHandler: function(evt) {
                // // preserve <a> capabilities as much as possible
                var target = null;

                // OSD 3.0
                if (evt.originalTarget){
                    target = evt.originalTarget;
                }
                // OSD 2.x
                else if (evt.originalEvent && evt.originalEvent.target) {
                    target = evt.originalEvent.target;
                }
                else {
                    return;
                }

                if (target.tagName === 'A') {
                    if (target.getAttribute('target') === '_blank') {
                        window.open(target.getAttribute('href'));
                    } else {
                        location.href = target.getAttribute('href');
                    }
                }
                else if (typeof(target.click) === "function"){
                    if (typeof(evt.quick) !== "undefined") {
                        if (evt.quick) {
                            target.click();
                        }
                    }
                    else {
                        target.click();
                    }
                }
            }
        });
        element.tracker = mouse_tracker;
    }
};

ABDOUtil._removeClass = function(element, css_class) {
    if (ABDOUtil.isIE) {
        element.setAttribute('class', element.getAttribute('class').replace(css_class, ' '));
    }
    else {
        element.classList.remove(css_class);
    }
};

ABDOUtil._on_dom_loaded = function(callback) {
    if (document.readyState === 'complete') {
        callback();
    }
    else {
        document.addEventListener('DOMContentLoaded', callback);
    }
};

/**
 * Gets abdo object from viewer, if not available returns null.
 * 
 * This object stores data necessary for ABDOMap and its submodules
 * @param {OpenSeadragon.Viewer} viewer  
 */
ABDOUtil.get_abdo = function(viewer) {
    var abdo = null;

    if (typeof(viewer.abdo) !== "undefined") {
        abdo = viewer.abdo;
    }

    return abdo;
};

/**
 * Returns the localization object associated to the viewer
 * @param {OpenSeadragon.Viewer} viewer 
 * @returns {ABDOMap.Localization}
 */
 ABDOUtil.get_viewer_localization = function(viewer) {
    if (typeof(viewer.abdo) !== "undefined" && typeof(viewer.abdo.localization) !== "undefined") {
        return viewer.abdo.localization;
    }
    
    return null;
},

ABDOUtil._resize_overlay = function(size, max_size){

    // max_size = 100.0 (default)
    if (typeof(max_size) !== 'number') {
        max_size = 100.0;
    }

    var xy_max = size.x;
    if (size.y > size.x) {
        xy_max = size.y;
    }

    // if max_size is larger than 100.0
    var scale = 1.0;
    
    if (xy_max > max_size) {
        scale = max_size / xy_max;
    } 
    
    size.x *= scale;
    size.y *= scale;
}

ABDOUtil.get_url_params = function() { 
    return new URLSearchParams(window.location.search || '');
}

ABDOUtil.update_map_links = function() {
    // a.map-linkのhrefを更新
    var url_params = ABDOUtil.get_url_params();
        
    var map_links = document.querySelectorAll("a.map-link");

    var idx;
    for (idx = 0; idx < map_links.length; idx++) {
        var a_element = map_links[idx];
        var href_url = new URL(a_element.href);
        href_url.search = url_params.toString(); 
        a_element.href = href_url.toString();
    } 
}

/**
 * Displays message on screen for debug purposes
 * @param {String} msg - message to show
 * @param {Number} timeout - if specified expire the message after timeout milliseconds
 */
    ABDOUtil.display_message = function(msg, timeout) {
    if (typeof(timeout) === "undefined") {
        timeout = 0;
    }

    var _class = "screen-message";
    var element = document.querySelector("div." + _class);
    
    if (!element) {
        /** @type {HTMLDivElement} */
        element = document.createElement("div");
        element.classList.add(_class); 
        document.body.appendChild(element);
    }

    element.innerText = msg;

    // if timeout specified detlte after timeout milliseconds
    if (timeout > 0) {
        setTimeout(function() {
            if (element.innerText == msg) {
                element.innerText = "";
            }
        }, timeout);
    }
},

ABDOUtil.toggle_screen_message = function() {
    var _class = "screen-message";
    var element = document.querySelector("div." + _class);
    
    if (element) {
        if (element.style.display === "none") {
            element.style.display = "";
        }
        else {
            element.style.display = "none";
        }
    }
} 
